import { render, staticRenderFns } from "./ChooseRoleSingle.vue?vue&type=template&id=1ebbabec&scoped=true"
import script from "./ChooseRoleSingle.vue?vue&type=script&lang=js"
export * from "./ChooseRoleSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebbabec",
  null
  
)

export default component.exports